import { call, put, select, take } from 'redux-saga/effects';
import { CABINET_URL } from '../Configurator/constants/furniture';
import { requestGet } from '../../utils/requests';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
import { CabinetJson } from '../../lib/modelBuilder/Data';
import { makeSelectFurniture } from '../Configurator/selectors/furniture';
import { updateCabinetSuccess } from '../Configurator/actions/furniture';
import ActionTypes from './constants';
import { addRefenceFailureAction, addRefenceSuccessAction } from './actions';

export default function* addReferenceSaga(): any {
  while (true) {
    const { payload } = yield take(ActionTypes.ADD_REFERENCE_REQUEST);
    const { reference } = payload;
    const url = `${CABINET_URL}/${reference}/`;
    try {
      const response = yield call(requestGet, url);
      const cabinet = Cabinet.fromModel(response as CabinetJson);
      if (cabinet) {
        const furniture = yield select(makeSelectFurniture());

        furniture.add(cabinet as Cabinet);
        yield put(updateCabinetSuccess(furniture.clone(), null));
        yield put(addRefenceSuccessAction());
      }
    } catch (error) {
      yield put(addRefenceFailureAction(error));
    }
  }
}
